<template>
  <div class="layout-remove-config-dialog">
    <div class="kye-dialog-body">
      <div class="remove-config-input">
        <kye-form>
          <kye-form-item label="用户" prop="name">
            <KyeEmployee
              v-model="form.name"
              clearable
              placeholder="请选择姓名/工号"
              @clear="handleClear"
              @select="handleSelect"
            >
            </KyeEmployee>
          </kye-form-item>
        </kye-form>
      </div>
      <div class="remove-config-footer">
        <kye-button round type="primary" size="small" hotkey="ctrl+s" @click="handleSubmit">
          清除(S)
        </kye-button>
        <kye-button round size="small" @click="handleClose">
          取消
        </kye-button>
      </div>
    </div>
  </div>

</template>

<script>
import { themeSystem } from '@/layout/layout/setup/theme-system/index'
export default {
  data() {
    return {
      form: {
        name: '',
        userId: ''
      }
    }
  },
  methods: {
    /**
     * 清除用户
     */
    handleClear() {
      this.form.name = ''
      this.form.userId = ''
    },
    /**
     * 选择用户
     */
    handleSelect(item) {
      const { name = '', id = '' } = item || {}
      this.form.name = name
      this.form.userId = id
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.$emit('close')
    },
    /**
     * 提交清除配置
     */
    handleSubmit() {
      const loginUserId = this.$store.getters.user.id
      const formUserId = this.form.userId
      themeSystem.removeConfig(formUserId)
      this.handleClose()
      if (!formUserId || loginUserId === formUserId) {
        window.__intercept__ = 0
        location.reload()
      } else {
        this.$message.success('清除成功')
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.layout-remove-config-dialog {
  .remove-config-footer {
    text-align: right;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/remove-config-dialog.vue